__turbopack_context__.v({
  "className": "avenirnextregular_251f05f7-module__DM5tOW__className",
  "variable": "avenirnextregular_251f05f7-module__DM5tOW__variable",
});
